import React from "react";
import "./index.css";

const ImageContainer = ({ imageUrl, width, height }) => {
  return (
    <div
      className="image-container"
      style={{ maxWidth: width, maxHeight: height }}
    >
      <img src={imageUrl} alt="User Provided" className="image" />
    </div>
  );
};

export default ImageContainer;
